import React, { useContext } from 'react';
import { Input } from 'reactstrap';
import { AnswersContext } from '../Survey';

export default function DropdownQuestion({ _id, data }) {
    const {
        submitAnswer,
        answers: { [_id]: value },
    } = useContext(AnswersContext);

    return (
        <div>
            <Input
                type="select"
                name={_id}
                value={value ?? 'NOANSWER'}
                id={_id}
                onChange={(e) => submitAnswer(_id, parseInt(e.target.value))}
                className="anl_survey--dropdown-input"
            >
                <option disabled value="NOANSWER">
                    Bitte treffen Sie eine Wahl
                </option>
                {data.map((item, index) => (
                    <option key={index} value={index}>
                        {item}
                    </option>
                ))}
            </Input>
        </div>
    );
}
